import { gql } from 'graphql-request'

export const CREATE_PEN_NAME = gql`
  mutation CreatePenName($createPenNameInput: CreatePenNameInput!) {
    createPenName(createPenNameInput: $createPenNameInput) {
      id
      firstPenName
      secondPenName
      facebookLink
      twitterLink
    }
  }
`
